import React, { useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { useHistory, useLocation } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { IconArrowLeft } from '@tabler/icons';

import api from '../../services/api';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationErrors';

import Button from '../../components/Button';
import Input from '../../components/Form/Input';
import { H1 } from '../../components/Generic';
import { Container } from './styles';

interface ResetPasswordData {
  password: string;
  passwordConfirm: string;
}

const SignUp: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  const history = useHistory();
  const location = useLocation();

  const handleSubmit = useCallback(
    async (data: ResetPasswordData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          password: Yup.string().min(
            6,
            'A senha deve ter no mínimo 6 dígitos.',
          ),
          passwordConfirm: Yup.string().oneOf(
            [Yup.ref('password'), null],
            'As senhas devem corresponder.',
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const token = location.search.replace('?token=', '');

        if (!token) {
          throw new Error();
        }

        await api.put('/senha/resetar', {
          senha: data.password,
          token,
        });

        history.push('/login');

        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Senha alterada.',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro!',
          description: err.response.data.message,
        });
      }
    },
    [addToast, history, location.search],
  );

  return (
    <Container>
      <div
        onClick={() => history.goBack()}
        style={{ marginBottom: 60, width: 30, cursor: 'pointer' }}
      >
        <IconArrowLeft size={30} color="#999" />
      </div>

      <H1>Criar nova senha</H1>

      <Form style={{ marginTop: 20 }} ref={formRef} onSubmit={handleSubmit}>
        <Input label="Senha" name="password" type="password" />

        <Input
          label="Confirme a senha"
          name="passwordConfirm"
          type="password"
        />

        <Button style={{ marginTop: 60 }} type="submit">
          Enviar
        </Button>
      </Form>
    </Container>
  );
};

export default SignUp;
